module.exports = __webpack_public_path__ + "static/img/frenl.5e90d04.png";


//////////////////
// WEBPACK FOOTER
// ./docs/assets/expo/frenl.png
// module id = 934
// module chunks = 2 8